import { Box, Button, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { endImpersonation } from '../../../redux/authSlice';

export default function ImpersonationBanner() {
	const dispatch = useAppDispatch();
	const theme = useTheme();
	const { impersonating, user } = useAppSelector(s => s.auth);

	if (!impersonating) {
		return null;
	}

	return (
		<Box
			sx={{
				position: 'fixed',
				top: 0,
				left: 0,
				width: '100%',
				height: 24,
				background: '#ff9800',
				color: '#fff',
				zIndex: theme.zIndex.drawer + 2,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				px: 2,
				py: 0.5,
			}}
		>
			<Typography variant="body2" color="white">
				⚠️ You are impersonating <b>{user?.username}</b>
			</Typography>
			<Button
				color="inherit"
				size="small"
				onClick={() => {
					dispatch(endImpersonation());
					window.location.reload();
				}}
			>
				End Impersonation
			</Button>
		</Box>
	);
}
